import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { Service } from '../model/service';
import { Specialize } from '../model/specialize';
import { ServiceMasterService } from '../services/service-master.service';
import { SpecializeMasterService } from '../services/specialize-master.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {
  srvData : Service = new Service(null,'',null);
  specializes: Specialize[] = Array<Specialize>();
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  isAdd  : boolean = true;
  servicesData : Service[];
  selectedObject : Service;
  specializeId: string ="null";
  user:any;
  constructor(private _sharedService: SharedService, private _srvService : ServiceMasterService,  private _spzService : SpecializeMasterService) { 
    this.isAdd= true;
     _sharedService.yesEmitted$.subscribe(
        text => {
            if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'SERVICE') {
                this.delete();
            } else {
                this.clearData();
            }
        });
  }

  getSpecializeDetail() : void {
    this.listLoading = true;
    this._spzService.getSpecializes().subscribe(
      data=>{
        this.listLoading = false;
          this.specializes  = data;
          if(this.specializes.length>0) {
            this.specializeId = this.specializes[0].SpecializeId.toString();
            this.getServiceDetail(this.specializes[0].SpecializeId);
          }
          
      },
      error=>{}
    );
 }
  getServiceDetail(id: number) : void {
    if(id != null && id !==0) {
      this.listLoading = true;
      this._srvService.getServiceDetail(id).subscribe(
        data=>{
            this.listLoading = false;
            this.servicesData  = data;
        },
        error=>{
          this.listLoading = false;
        }
      );
    }
    
  }
  clearData() : void {
        this.srvData.ServiceId= null;
        this.srvData.ServiceName="";
        //this.srvData.SpecializeId = null;
        this.isAdd= true;
  }
  cancelData() : void {
     if(this.isAdd) {
       this.clearData();
     } else {
       this._sharedService.emitDialog(true,"Cancel",ActionMessage.CANCEL.toString(),true, DialogAction.CANCEL.toString(), 'SERVICE' );
     }
       
  }
  editService(srvEditObject : Service) : void {
     this.isAdd = false;
     this.srvData = Object.assign(Object.create(srvEditObject), srvEditObject);
     //this.specializeId = srvEditObject.SpecializeId.toString();
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.getSpecializeDetail();
  }
  saveService() : void {
      this.loading = true;
      this.srvData.SpecializeId =parseInt(this.specializeId);
      this._srvService.data = this.srvData;
      if(this.isAdd){
        this.addService();
      } else {
        this.updateService();
      }
  }
  addService() :void { 
       this._srvService.saveService().subscribe(data=>{
        this.loading = false;
        this.message = "Service "+ ActionMessage.SAVESUCCESS.toString();
        this.clearData();
        this.getServiceDetail(parseInt(this.specializeId));
        this.hideMessage();
      },
      error=>{
          this.loading = false;
          if(error.data !== undefined) {
            this.message = error.data;
          } else {
            this.message = JSON.parse(error._body).Message;
          }
          this.hideMessage();
      });
    }
  updateService() :void {
     
      this._srvService.updateServiceDetail().subscribe(data=>{
        this.loading = false;
        this.message = "Service "+ ActionMessage.UPDATESUCCESS.toString();
        this.clearData();
        this.getServiceDetail(parseInt(this.specializeId));
        this.hideMessage();
      },
      error=>{
          this.loading = false;
          if(error.data !== undefined) {
            this.message = error.data;
          } else {
            this.message = JSON.parse(error._body).Message;
          }
          this.hideMessage();
      });
  } 
  delete() :void {
      this.listLoading = true;
      this._srvService.deleteService(this.selectedObject).subscribe(data=>{
        this.listLoading = false;
        this.message = "Service " + ActionMessage.DELETESUCCESS.toString();
        this.clearData();
        this.getServiceDetail(this.srvData.SpecializeId);
        this.hideMessage();
      },
      error=>{
          this.listLoading = false;
          if(error.data !== undefined) {
            this.message = error.data;
          } else {
            this.message = JSON.parse(error._body).Message;
          }
          this.hideMessage();
      });
  }
  hideMessage() : void {
    setTimeout(() => {
      this.message = '';
    }, 1000);
  }
  deletService(org : Service) :void {
    this.selectedObject = org;
    this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(), 'SERVICE' );      
  }
  ngAfterViewChecked() {
     this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
     this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/service/service.component.ts